<template>
  <div class="referrerInfo">
    <QS-h4-title title="推荐方" />
    <QS-column-box
      :source="source"
      :list="list"
      :column="3"
      labelWidth="150"
      separator=":"
    >
      <template slot="recommenderRewardAmount">
        {{ recommendAmount }}
      </template>
    </QS-column-box>
  </div>
</template>

<script>
export default {
  props: {
    source: {
      type: Object,
      default: () => {},
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    // 推荐奖励金额
    recommendAmount() {
      const amount = this.source.recommenderRewardAmount
      return amount === 0 ? '0' : (amount || '-')
    },
  },
}
</script>

<style lang="scss" scoped>
.referrerInfo{

}
</style>
